import PropTypes from "prop-types";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

import MDTypography from "shared/ui/Typography/MDTypography";
import MDBox from "shared/ui/Box/MDBox";

function ConfirmDeleteProgramDialog({ open, program, onConfirm, onCancel }) {
  if (!program) return null;

  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="confirm-delete-program">
      <DialogTitle id="confirm-delete-program" sx={{ textAlign: "center" }}>
        Eliminar programa
      </DialogTitle>

      <DialogContent>
        <MDTypography variant="body2" mb={2} textAlign="center">
          ¿Estás seguro de que quieres eliminar este programa?
        </MDTypography>

        <MDBox textAlign="center" mt={1}>
          <MDTypography variant="subtitle2" fontWeight="medium">
            {program.title}
          </MDTypography>

          {program.clientName && (
            <MDTypography variant="caption" color="text.secondary">
              Cliente: {program.clientName}
            </MDTypography>
          )}
        </MDBox>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", gap: 2 }}>
        <Button onClick={onCancel}>Cancelar</Button>

        <Button onClick={onConfirm} color="error" variant="contained">
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmDeleteProgramDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  program: PropTypes.shape({
    title: PropTypes.string.isRequired,
    clientName: PropTypes.string,
  }),
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmDeleteProgramDialog;
